module.exports = __webpack_public_path__ + "b35d53e18beca916c2b41565565203e4.pdf";